import React from "react";
import { Link } from "react-router-dom";
import "./featuredProperty2.css";
import Manor from "../assets/manor.jpg";
import Garden from "../assets/garden.jpg";
import { FaArrowRight } from "react-icons/fa";

const FeaturedPropertySection2 = () => {
  return (
    <section className="property-showcase">
      <h2 className="showcase-title">Our Premium Estates</h2>
      <div className="property-grid">
        {/* Property 1 - Heaven */}
        <Link to="/heaven" className="property-item">
          <div className="property-card">
            <div className="property-image-container">
              <img
                src="/assets/images/haven/haven45.jpg"
                alt="Highbridge Heaven"
                className="property-image"
                style={{ objectPosition: "top" }}
              />
            </div>
            <div className="property-content">
              <h3 className="property-title ">HIGHBRIDGE Haven</h3>{" "}
              <FaArrowRight />
            </div>
          </div>
        </Link>

        {/* Property 2 - Residence */}
        <Link to="/residence" className="property-item">
          <div className="property-card">
            <div className="property-image-container">
              <img
                src="/assets/images/residences/residence.jpg"
                alt="Highbridge Residences"
                className="property-image"
                style={{ objectPosition: "top" }}
              />
            </div>
            <div className="property-content">
              <h3 className="property-title ">HIGHBRIDGE Residence ESTATE</h3>{" "}
              <FaArrowRight />
            </div>
          </div>
        </Link>

        {/* Property 3 - County */}
        <Link to="/highbridge-county" className="property-item">
          <div className="property-card">
            <div className="property-image-container">
              <img
                src="/assets/images/county/COUNTY.jpg"
                alt="Highbridge County"
                className="property-image"
                style={{ objectPosition: "top" }}
              />
            </div>
            <div className="property-content">
              <h3 className="property-title ">HIGHBRIDGE County ESTATE</h3>{" "}
              <FaArrowRight />
            </div>
          </div>
        </Link>

        {/* Property 4 - Manor */}
        <Link to="/highbridge-manor" className="property-item">
          <div className="property-card">
            <div className="property-image-container">
              <img
                src={Manor}
                alt="HighBridge Manor"
                className="property-image"
                style={{ objectPosition: "top" }}
              />
            </div>
            <div className="property-content">
              <h3 className="property-title ">HIGHBRIDGE Manor ESTATE</h3>{" "}
              <FaArrowRight />
            </div>
          </div>
        </Link>

        {/* Property 5 - Magistic Lagos */}
        <Link to="/magistic-lagos" className="property-item">
          <div className="property-card">
            <div className="property-image-container">
              <img
                src="/assets/images/magestic/magestic.jpg"
                alt="Magistic Lagos"
                className="property-image"
                style={{ objectPosition: "top" }}
              />
            </div>
            <div className="property-content">
              <h3 className="property-title ">Magistic Lagos</h3>{" "}
              <FaArrowRight />
            </div>
          </div>
        </Link>

        {/* Property 6 - Farmcity */}
        <Link to="/farmcity" className="property-item">
          <div className="property-card">
            <div className="property-image-container">
              <img
                src="/assets/images/farmcity/farmcity.jpg"
                alt="Highbridge Farmcity"
                className="property-image"
                style={{ objectPosition: "top" }}
              />
            </div>
            <div className="property-content">
              <h3 className="property-title ">HIGHBRIDGE Farmcity</h3>
              <FaArrowRight />
            </div>
          </div>
        </Link>

        {/* Property 7 - Garden */}
        <Link to="/garden" className="property-item">
          <div className="property-card">
            <div className="property-image-container">
              <img
                src={Garden}
                alt="Highbridge Garden"
                className="property-image"
                style={{ objectPosition: "top" }}
              />
            </div>
            <div className="property-content">
              <h3 className="property-title ">Garden ESTATE</h3>
              <FaArrowRight />
            </div>
          </div>
        </Link>
      </div>
    </section>
  );
};

export default FeaturedPropertySection2;
